import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  DateFormatPipe,
  DatetimeFormatterModule,
} from '@soctrip-common/datetime-formatter';
import { ClipboardModule } from 'ngx-clipboard';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { ImageModule } from 'primeng/image';
import { InputTextModule } from 'primeng/inputtext';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SidebarModule } from 'primeng/sidebar';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TreeSelectModule } from 'primeng/treeselect';
import { CoreModule } from '../core/core.module';
import { Countries } from '../core/models/classes/countries';
import { SentenceCasePipe } from '../core/pipes/sentence-case.pipe';
import { ShortNumberPipe } from '../core/pipes/short-number.pipe';
import { AlphaNumericDirective } from '../directives/alpha-numeric.directive';
import { DragAndDropDirective } from '../directives/drag-and-drop.directive';
import { ButtonComponent } from './components/button/button.component';
import { CustomImageComponent } from './components/custom-image/custom-image.component';
import { FlagsDropdownComponent } from './components/dropdowns/flags-dropdown/flags-dropdown.component';
import { HeaderComponent } from './components/header/header.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { PanelComponent } from './components/panel/panel.component';
import { SelectTimeComponent } from './components/select-time/select-time.component';
import { TableEmptyComponent } from './components/table-empty/table-empty.component';
import { TabViewComponent } from './components/tabview/tabview.component';
import { ToastMessageComponent } from './components/toast-message/toast-message.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { SidebarLayoutComponent } from './layouts/sidebar-layout/sidebar-layout.component';
import { WelcomeLayoutComponent } from './layouts/welcome-layout/welcome-layout.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TooltipModule } from 'primeng/tooltip';
import { RippleModule } from 'primeng/ripple';
import { FormatBytesPipe } from '../core/pipes/format-bytes.pipe';

@NgModule({
  declarations: [
    FlagsDropdownComponent,
    ButtonComponent,
    CustomImageComponent,
    HeaderComponent,
    DragAndDropDirective,
    PaginatorComponent,
    ToastMessageComponent,
    AlphaNumericDirective,
    TabViewComponent,
    TableEmptyComponent,
    AdminLayoutComponent,
    SidebarLayoutComponent,
    PanelComponent,
    ShortNumberPipe,
    SelectTimeComponent,
    WelcomeLayoutComponent,
    SidebarComponent,
    FormatBytesPipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    DropdownModule,
    FormsModule,
    CoreModule,
    ButtonModule,
    FileUploadModule,
    ImageModule,
    SidebarModule,
    TableModule,
    DialogModule,
    PaginatorModule,
    TreeSelectModule,
    InputTextModule,
    TranslateModule,
    ToastModule,
    SkeletonModule,
    DialogModule,
    OverlayPanelModule,
    ClipboardModule,
    CalendarModule,
    ProgressSpinnerModule,
    DatetimeFormatterModule,
    SidebarModule,
    TooltipModule,
    RippleModule,
  ],
  exports: [
    FlagsDropdownComponent,
    ButtonComponent,
    CustomImageComponent,
    HeaderComponent,
    TranslateModule,
    DragAndDropDirective,
    SentenceCasePipe,
    PaginatorComponent,
    ToastMessageComponent,
    AlphaNumericDirective,
    TabViewComponent,
    TableEmptyComponent,
    PanelComponent,
    ShortNumberPipe,
    SelectTimeComponent,
    DateFormatPipe,
    FormatBytesPipe,
  ],
  providers: [Countries],
})
export class SharedModule {}
